import Axios from 'axios'
import { merge, isUndefined } from 'lodash'
import { Toast } from '@gidc/mobile'
import { Dialog } from 'mand-mobile'

/**
 * axios实例化对象
 */

class AxiosInstance {
  #Axios = null
  #CancelToken = Axios.CancelToken
  #queue = []

  /**
   * 设置当前请求token
   * @param {string} path
   * @param {string} method
   * @returns {string}
   */
  #getToken = ({ path, method }) => {
    return `${path}_${method}`
  }

  /**
   * 添加请求队列
   */
  #addQueue = config => {
    return new this.#CancelToken(cancel => {
      this.#queue.push({
        // token: this.#getToken(config),
        cancel
      })
    })
  }

  /**
   * 移除请求队列
   */
  #removeQueue = config => {
    const index = this.#queue.findIndex(q => q.token === this.#getToken(config))
    if (index > -1) {
      this.#queue[index].cancel()
      this.#queue.splice(index, 1)
    }
  }

  constructor (config) {
    config = merge(
      {
        baseURL: process.env.VUE_APP_REQUEST_BASH_URL, // 因为我本地做了反向代理
        timeout: 100 * 1000, // 超时处理
        responseType: 'json', // 响应数据类型
        withCredentials: true, // 是否允许带cookie这些
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      },
      config
    )
    this.#Axios = Axios.create(config)

    this.#Axios.interceptors.request.use(config => {
      Toast.loading(' loading... ')
      this.#removeQueue(config)
      config.cancelToken = this.#addQueue(config)
      return config
    }, error => {
      console.error(error)
      this.#removeQueue(error.config)
      Toast.hide()
      Toast.failed('fail to load')
    })

    this.#Axios.interceptors.response.use(response => {
      Toast.hide()
      this.#removeQueue(response.config)
      console.log('this is response.data', response)
      return response.data
    }, error => {
      console.error(error)
      this.#removeQueue(error.config)
      Toast.hide()
      Toast.failed('fail loading')
    })

    return this.#Axios
  }
}

/**
 * api构造函数
 * 抽象工厂
 */
class Request {
  constructor (config = {}) {
    this.request = new AxiosInstance(config = {})
    // console.log('this is request', this.request)
  }

  #confirm = null
  #cancle = null
  setBtn (confirm, cancle) {
    this.#confirm = confirm
    this.#cancle = cancle
  }

  /**
   * post请求
   * @param {string} url
   * @param {object} [data = {}] data
   * @param {object} [config = {}] config
   * @returns {Promise<resolve, reject>}
   */
  post (url, data = {}, config = {}) {
    if (isUndefined(url)) {
      throw new Error('请求地址不能为空')
    }
    // return this.request.post(url, data, config)
    console.log('this congif', config)
    return new Promise((resolve, reject) => {
      this.request.post(url, data, config)
        .then(res => {
          if (res.status === '200') {
            console.log('sttst = ===200')
            resolve(res)
          } else if (res.status === '8888') {
            resolve(res)
          } else if (res.status === '503') {
            window.emitRNFunction('goToLogin')
            // Dialog.alert({
            //   content: res.msg,
            //   confirmText: this.#todo1,
            //   onConfirm: () => console.log('[Dialog.failed] confirm clicked')
            // })
          } else if (res.status === '1011') {
            // window.emitRNFunction('goToLogin')
            Dialog.alert({
              content: res.msg,
              confirmText: this.#confirm
            })
          } else if (res.status === '1111') {
            // window.emitRNFunction('goToLogin')
            resolve(res)
          } else if (res.status === '1112') {
            // window.emitRNFunction('goToLogin')
            Dialog.alert({
              content: res.msg,
              confirmText: this.#confirm
            })
          } else if (res.status === '1113') {
            // window.emitRNFunction('goToLogin')
            Dialog.alert({
              content: res.msg,
              confirmText: this.#confirm
            })
          } else if (res.status === '11111111') {
            // window.emitRNFunction('goToLogin')
            Dialog.alert({
              content: res.msg,
              confirmText: this.#confirm
            })
          } else if (res.status === '7775') {
            resolve(res)
          } else if (res.status === '7777') {
            Toast.failed(res.msg)
          } else if (res.status === '7779') {
            resolve(res)
          } else if (res.status === '4012') {
            resolve(res)
          } else if (res.status === 'CE01') {
            resolve(res)
          } else {
            Toast.failed(res.msg)
            console.log('reject')
            reject(res)
          }
          // console.log(this.$refs.abc.style.cssText)
        })
    })
  }

  /**
   * get请求
   * @param {string} url
   * @param {object} [data = {}] data
   * @param {object} [config = {}] config
   * @returns {Promise<resolve, reject>}
   */
  get (url, data = {}, config = {}) {
    if (isUndefined(url)) {
      throw new Error('请求地址不能为空')
    }
    // return this.request.get(url, data, config)
    return new Promise((resolve, reject) => {
      this.request.request(url, data = {}, config = {})
        .then(res => {
          if (res.status === '200') {
            resolve(res)
          }
        })
    })
  }
}

export {
  Request
}

export default AxiosInstance
